module.exports = __webpack_public_path__ + "static/media/image7.968ea042.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/KiaKids/image7.jpg
// module id = 1214
// module chunks = 0